define('home/views/FollowerCardView',[
    'home/views/UserCardView',
    'home/templates/followerCard',

], function (
    UserCardView,
    followerCardTemplate
) {
    'use strict';

    return UserCardView.extend({
        initialize: function (options) {
            UserCardView.prototype.initialize.call(this, options);
            this.showRemoveButton = options.showRemoveButton;
        },

        template: followerCardTemplate,

        templateHelpers: function () {
            var helpers = UserCardView.prototype.templateHelpers.call(this);
            helpers.showRemoveButton = this.showRemoveButton;
            return helpers;
        },
    });
});

